/**
 * Card image URL construction for ShareCardButton, extracted so the logic is
 * testable without jsdom.
 *
 * jest-client is served from the Jest origin (https://<gameId>.builds.jest.com)
 * while the API lives at API_BASE, so any URL handed to the user or an <img>
 * must target the API host — a path resolved against the page origin points at
 * a static build host that serves no /api routes.
 */

export type CardVariant = 'prediction' | 'winner';

export function cardImagePath(variant: CardVariant, undercardEntryId: string): string {
  return variant === 'winner'
    ? `/api/cards/winner/${undercardEntryId}`
    : `/api/cards/prediction/${undercardEntryId}`;
}

/**
 * Absolute URL for copy-link / native share. Uses the API origin; the page
 * origin is only a fallback for same-origin setups where API_BASE is empty.
 */
export function absoluteCardImageUrl(
  apiBase: string,
  pageOrigin: string,
  variant: CardVariant,
  undercardEntryId: string
): string {
  return `${apiBase || pageOrigin}${cardImagePath(variant, undercardEntryId)}`;
}
